import React, { useEffect } from "react";
import {
    ClearFiltersButton,
    ContentSection,
    createListTableColumns,
    Grid,
    GridColumn,
    GridRow,
    ListTable,
    SearchBox,
    Stack
} from "sprint-common-web";

import { LanguageCodeMappingItem } from "../../LanguageSpecificationDashboardItem";
import { EditLanguageCodeMappingButton } from "../edit/EditMappingButton";
import { useMappingListingFilters } from "./useMappingListingFilters";
import { useMappingsListing } from "./useMappingsListing";

export const MappingsListing: React.FC = () => {
    const { filters, setSort, setName, clearFilters, setPage, setPageSize } = useMappingListingFilters();
    const { items, allItems, totalItems, isLoading, saveData } = useMappingsListing();

    useEffect(() => {
        saveData(filters);
    }, [filters, allItems]);

    const columns = createListTableColumns<LanguageCodeMappingItem>([
        {
            type: "basic",
            key: "languageName",
            name: "Language",
            minWidth: 120,
            maxWidth: 120,
            isSortable: true
        },
        {
            type: "basic",
            key: "soundtrackCode",
            name: "Soundtrack code",
            minWidth: 170,
            maxWidth: 200
        },
        {
            type: "basic",
            key: "subtitleCode",
            name: "Subtitle code",
            minWidth: 170,
            maxWidth: 200
        },
        {
            type: "buttons",
            key: "actions",
            name: "Actions",
            minWidth: 64,
            maxWidth: 64,
            buttons: [
                {
                    id: "EditLanguageCodeMapping",
                    getItemId: (item) => item.languageId,
                    render: EditLanguageCodeMappingButton
                }
            ]
        }
    ]);

    return (
        <ContentSection header="Mappings">
            <Grid>
                <GridRow>
                    <GridColumn sm={4}>
                        <SearchBox placeholder="Name" onChange={setName} value={filters.name} />
                    </GridColumn>

                    <GridColumn sm={8}>
                        <Stack horizontalAlign="end">
                            <ClearFiltersButton onClear={clearFilters} isLabeled={true} />
                        </Stack>
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn sm={12}>
                        <ListTable
                            columns={columns}
                            items={items}
                            pagination={{
                                page: filters.page,
                                pageSize: filters.pageSize,
                                totalItems,
                                onPageChange: setPage,
                                onPageSizeChange: setPageSize
                            }}
                            isLoading={isLoading}
                            onSortChange={setSort}
                            sort={{ by: filters.sortBy, order: filters.sortOrder }}
                        />
                    </GridColumn>
                </GridRow>
            </Grid>
        </ContentSection>
    );
};
